// 租户，会议室，会议类型、会议参数配置编号
const configNos = {
  state: {
    // 会议/会议类型参数配置编号
    meetingConfigNos:{
      // 会议单位：会议模式、议题模式
      meeting_unit:"MEETING_UNIT",

      // 会议预开始开关
      enable_meeting_prep_start:"ENABLE_MEETING_PREP_START",

      // 文件保存方式
      datum_save_method:"DATUM_SAVE_METHOD",

      // 登入方式：指纹、人脸、账号密码、直接
      login_method:"LOGIN_METHOD",

      // 计时器配置：同屏或者协同的时候是否显示汇报时间倒计时
      show_timer:"SHOW_TIMER",

      // 文件水印配置：开启
      enable_file_watermark:"ENABLE_FILE_WATERMARK",

      // 启用资料查看权限：启动，上传资料就可以选择对应人员查看对应资料
      enable_file_authority:"ENABLE_FILE_AUTHORITY",

      // 启动会议自动开关：开启，会议到时间自动开启，到结束时间就自动结束
      enable_auto_open_close:"ENABLE_AUTO_OPEN_CLOSE",

      // 电子围栏监控 0:开启，1：关闭，-1：功能关闭
      enable_electronic_fence:"ENABLE_ELECTRONIC_FENCE",

      // 启动自动删除离线文件开关：开启删除离线文件开关，会议结束或者退出无纸化系统会自动删除会议文件，在进去系统的时候也要进行判断此会议是否结束，如果结束也要自动删除
      enable_clear_offline_file:"ENABLE_CLEAR_OFFLINE_FILE",

      // 禁止文件下载开关：如果启动，在上传文件的时候可以选择文件是否离线查看
      disable_file_download:"DISABLE_FILE_DOWNLOAD",

      // 启用二级密码验证
      enable_second_level_pass:"ENABLE_SECOND_LEVEL_PASS",

      // 来宾名称配置：配置来宾显示名称，默认”来宾“
      guest_name:"GUEST_NAME",

      // 离线文件是否加密开关
      encrypt_offline_file:"ENCRYPT_OFFLINE_FILE",

      // 资料进行加密存储
      file_encrypt_storage:"FILE_ENCRYPT_STORAGE",

      // pad主题
      theme_pad:"THEME_PAD",

      // 大屏主题
      theme_bigscreen:"THEME_BIGSCREEN",

      // 升降器主题
      theme_elevator:"THEME_ELEVATOR",

      // 参会密码
      meeting_password:"MEETING_PASSWORD",

      // 启用保密会议
      enable_secrecy_meeting:"ENABLE_SECRECY_MEETING",
    },
    // 租户参数配置编号
    tenantonfigNos:{
      // logo配置
      tenant_logo_config:"TENANT_LOGO_CONFIG",

      // 微信公众号配置
      wechat_public_config:"WECHAT_PUBLIC_CONFIG",

      // 微信小程序配置
      wechat_miniapp_config:"WECHAT_MINIAPP_CONFIG",

      // 企业微信应用配置
      wecom_application_config:"WECOM_APPLICATION_CONFIG",

      // 钉钉应用配置
      dingding_application_config:"DINGDING_APPLICATION_CONFIG",

      // 语音识别
      enable_speech_recognition:"ENABLE_SPEECH_RECOGNITION",

      // 识别服务地址
      speech_recognition_wsurl:"SPEECH_RECOGNITION_WSURL",

      // 离线功能
      off_line: "OFF_LINE",

      // 启用电子围栏
      enable_electronic_fence: "ENABLE_ELECTRONIC_FENCE",

      // 启用会议室WiFi管理
      enable_wifi_white_list: "ENABLE_WIFI_WHITE_LIST",

      // 鸿蒙平板定时开机
      device_harmony_pad_timing_poweron:"DEVICE_HARMONY_PAD_TIMING_POWERON",

      // 荣耀平板定时开机
      device_honor_pad_timing_poweron:"DEVICE_HONOR_PAD_TIMING_POWERON",

      // 联想平板定时开机
      device_lenovo_pad_timing_poweron:"DEVICE_LENOVO_PAD_TIMING_POWERON",

      // 联想平板定时关机
      device_lenovo_pad_timing_poweroff:"DEVICE_LENOVO_PAD_TIMING_POWEROFF",

      // 平板壁纸
      device_pad_wallpaper_image:"DEVICE_PAD_WALLPAPER_IMAGE",

      // 平板屏保
      device_pad_screensavers_image:"DEVICE_PAD_SCREENSAVERS_IMAGE",

      // 设备启动背景图
      app_launch_background_img:"APP_LAUNCH_BACKGROUND_IMG",

      // 电子白板
      white_board_background:"WHITE_BOARD_BACKGROUND",

      // 是否开启密级
      enable_meeting_secret_level:"ENABLE_MEETING_SECRET_LEVEL",

      // 网站浏览配置
      website_browser_config:"WEBSITE_BROWSER_CONFIG",

      // 会议资料目录最大深度
      meeting_datum_catalogue_max_depth: "MEETING_DATUM_CATALOGUE_MAX_DEPTH",

      // 微信公众号消息配置
      wechat_public_message_config:"WECHAT_PUBLIC_MESSAGE_CONFIG",

      // 门牌人脸相似度配置
      user_face_similarity:"USER_FACE_SIMILARITY",

      // 门牌登录配置
      door_plate_login_method:"DOOR_PLATE_LOGIN_METHOD",
    },

    // 会议室参数配置编号
    boardroomConfigNos:{
      // 文件水印配置
      file_watermark:"FILE_WATERMARK",

      // 桌牌线程数配置
      table_card_thread_number:"TABLE_CARD_THREAD_NUMBER",

      // 中控控制开关
      center_control_switch:"CENTER_CONTROL_SWITCH",

      // 推流配置
      push_stream:"PUSH_STREAM",

      // 远程信号
      remote_signal:"REMOTE_SIGNAL",

      // 云盘wifi配置
      cloud_disk_wifi:"CLOUD_DISK_WIFI",

      // 升降命令类型配置
      lifting_command_type:"LIFTING_COMMAND_TYPE",

      // 启用条形码配置
      enable_bar_coding:"ENABLE_BAR_CODING",

      // 启用文件发送邮件
      enable_file_send_email:"ENABLE_FILE_SEND_EMAIL",

      // WiFi白名单
      wifi_white_list:"WIFI_WHITE_LIST",

      // 电子围栏配置
      electronic_fence_list:"ELECTRONIC_FENCE_LIST",

      // 电子围栏配置版本
      electronic_fence_version:"ELECTRONIC_FENCE_VERSION",

      // 桌牌自动绑定
      enable_node_table_automatic_bind:"ENABLE_NODE_TABLE_AUTOMATIC_BIND",

      // 升降终端子网掩码配置
      elevator_node_subnet_mask:"ELEVATOR_NODE_SUBNET_MASK",

      // 桌牌配置
      table_config:"TABLE_CONFIG",

      //文件下载路径配置
      file_download_url:"FILE_DOWNLOAD_URL",
    },

    // 系统级参数配置
    systemConfigNos:{
      // 终端数量配置（终端最大数量限制）
      node_number:"NODE_NUMBER",

      // 显示名称方式
      show_name_method: "SHOW_NAME_METHOD",

      // 启用多会议室功能
      enable_multi_room: "ENABLE_MULTI_ROOM",

      // 终端离线资源版本号
      offline_node_page_version: "OFFLINE_NODE_PAGE_VERSION",

      // 大屏离线资源版本号
      offline_bigscreen_page_version: "OFFLINE_BIGSCREEN_PAGE_VERSION",

      // 门牌离线资源版本号
      offline_doorplate_page_version: "OFFLINE_DOORPLATE_PAGE_VERSION",

      // 大屏换行符
      bigscreen_linebreak: "BIGSCREEN_LINEBREAK",

      // 启用席媒移动盘
      enabled_media_mobile_disk: "ENABLED_MEDIA_MOBILE_DISK",

      // pdf切图方式
      pdf_conver_image_method: "PDF_CONVER_IMAGE_METHOD",

      // 通知方式
      meeting_notification_method: "MEETING_NOTIFICATION_METHOD",

      // TCP次数延迟配置
      tcp_times_config: "TCP_TIMES_CONFIG",

      // 特殊字符开关
      special_character_switch: "SPECIAL_CHARACTER_SWITCH",

      // WiFi墨水屏服务IP配置
      wifi_eink_service_ip: "WIFI_EINK_SERVICE_IP",

      // 登录验证码开关
      verification_code: "VERIFICATION_CODE",

      // COM口监听配置
      com_port_config: "COM_PORT_CONFIG",

      // COM命令延迟配置
      com_times_config: "COM_TIMES_CONFIG",

      // 手机端首页地址
      mobile_application_index: "MOBILE_APPLICATION_INDEX",

      // 电子围栏版本
      electronic_fence_version_list: "ELECTRONIC_FENCE_VERSION_LIST",

      // 上报时间间隔
      equmonitoring_offline_time: "EQUMONITORING_OFFLINE_TIME",

      // 监控历史保留时间
      equmonitoring_history_time: "EQUMONITORING_HISTORY_TIME",

      // 电子围栏提示框
      blueTooth_dialog: "BLUETOOTH_DIALOG",

      // 电量提醒阈值
      battery_low: "BATTERY_LOW",

      // 阿里云短信消息配置
      ali_yun_sms_config:"ALI_YUN_SMS_CONFIG",

      // 阿里云语音消息配置
      ali_yun_call_config:"ALI_YUN_CALL_CONFIG",

      // 邮件消息配置
      email_message_config:"EMAIL_MESSAGE_CONFIG",

      // 可立控别名白名单
      klk_white_borrow_node:"KLK_WHITE_BORROW_NODE",

      // 终端主题列表
      node_theme_list_config:"NODE_THEME_LIST_CONFIG",

      // 安卓客户端版本
      android_app_version: "ANDROID_APP_VERSION",

      // 安卓大屏端版本
      android_bigscreen_version: "ANDROID_BIGSCREEN_VERSION",

      // windows客户端版本
      windows_app_version: "WINDOWS_APP_VERSION",

      // linux客户端版本
      linux_app_version: "LINUX_APP_VERSION",

      // 大屏客户端版本
      bigscreen_app_version: "BIGSCREEN_APP_VERSION",

      // 门牌客户端版本
      doorplate_app_version: "DOORPLATE_APP_VERSION",

      // MQTT服务配置
      mqtt_config:"MQTT_CONFIG",

      // 启用日志记录
      enable_log_record: "ENABLE_LOG_RECORD",

      // 终端数量配置（终端最大数量限制）
      node_number:"NODE_NUMBER",
    }
  },
};

export default configNos;



// WEBPACK FOOTER //
// ./src/store/modules/configNos.js